import React from "react";
import { getOptimizedImageUrl } from "../lib/cms";

export default function CleanupSection({ className = "" }) {
  const options = [
    {
      icon: "fa-solid fa-trailer",
      title: "Trailerstykker",
      desc: "Træet saves i praktiske stykker, så du nemt selv kan læsse det og køre bort på egen trailer.",
    },
    {
      icon: "fa-solid fa-recycle",
      title: "Flishugning i haven",
      desc: "Grene flishugges effektivt, og flisen kan genbruges som bunddække i havens bede.",
    },
    {
      icon: "fa-solid fa-fire",
      title: "Savning til brænde",
      desc: "Stammer og større grene saves i brændestykker – klar til at blive kløvet.",
    },
    {
      icon: "fa-solid fa-truck-moving",
      title: "Fuld bortskaffelse",
      desc: "Alt træ, grene og kvas køres væk, så haven efterlades ren, pæn og ryddet.",
    },
  ];

  return (
    <section className={`py-14 sm:py-20 bg-[#F4EFE6] border-t border-[#E5DDCF] overflow-hidden ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Text & options (7 cols) */}
          <div className="lg:col-span-7 space-y-6">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#152E22] tracking-tight">
              Oprydning efter arbejdet – som det passer dig
            </h2>

            <div className="space-y-3 text-sm sm:text-base text-[#3C5345] leading-relaxed">
              <p>
                Efter fældning eller beskæring kan træet saves i praktiske trailerstykker, så du nemt selv kan stå for oprydning og bortskaffelse.
              </p>
              <p>
                Ønsker du hjælp, tilbydes komplet oprydning, hvor grene flishugges og flisen kan blive i haven. Stammer og større grene saves i håndterbare længder eller brændestykker – eller fjernes helt, så haven efterlades pæn og ryddet.
              </p>
            </div>

            {/* Options grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 pt-2">
              {options.map((opt, idx) => (
                <div
                  key={idx}
                  className="bg-white p-4 rounded-xl border border-[#E6DEC8] shadow-sm hover:border-[#1e5d31]/40 transition-colors"
                >
                  <div className="w-9 h-9 rounded-lg bg-[#F2ECE1] text-[#D9691E] flex items-center justify-center text-lg mb-2.5">
                    <i className={opt.icon} aria-hidden="true" />
                  </div>
                  <h3 className="font-bold text-sm sm:text-base text-[#152E22]">
                    {opt.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-[#476051] mt-1 leading-relaxed">
                    {opt.desc}
                  </p>
                </div>
              ))}
            </div>

            <p className="text-xs sm:text-sm font-medium text-[#1E5D31] bg-[#1e5d31]/8 pl-0 pr-4 py-2.5 rounded-lg border border-[#1e5d31]/15 inline-block">
              <i className="fa-solid fa-circle-check text-[#D9691E] mr-2" aria-hidden="true" />
              Du bestemmer altid selv, hvor meget eller lidt du ønsker hjælp til.
            </p>
          </div>

          {/* Image & photo callout (5 cols) */}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-lg border border-[#E2D8C8] h-[360px] sm:h-[420px] lg:h-[480px]">
              <img
                src={getOptimizedImageUrl(
                  "https://assets.auxodev.dk/assets/e431b544-04c3-4ed0-906f-0354609bd752/615369939-881992974627605-6313467560989915482-n.webp",
                  800,
                  85
                )}
                alt="Oprydning og flishugning efter fældning og beskæring"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 p-4 rounded-xl bg-black/40 backdrop-blur-sm border border-white/15 text-white">
                <p className="font-semibold text-sm">
                  Effektiv flishugning & bortkørsel
                </p>
                <p className="text-xs text-white/80 mt-0.5">
                  Maskiner og trailer haves til både trange haver og større ejendomme.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
